import { isPlatformBrowser } from '@angular/common';
import type { OnDestroy } from '@angular/core';
import { PLATFORM_ID, inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { Subject } from 'rxjs';

/**
 * Why do we need this?
 * We are listening for global clicks in a directive that is used in quite a few components
 * that is creating a lot of listeners on the document. This service is a way to centralize it
 * so we only need to make 1 listener on the document.
 */
@Injectable({ providedIn: 'root' })
export class GlobalClickService implements OnDestroy {
  private platformId = inject(PLATFORM_ID);

  private clickedSubject$ = new Subject<MouseEvent>();
  private initialised = false;

  private listener = (event: MouseEvent): void =>
    this.clickedSubject$.next(event);

  get clicked$(): Observable<MouseEvent> {
    if (isPlatformBrowser(this.platformId) && !this.initialised) {
      document.addEventListener('mousedown', this.listener);
      this.initialised = true;
    }

    return this.clickedSubject$.asObservable();
  }

  ngOnDestroy(): void {
    if (this.initialised) {
      document.removeEventListener('mousedown', this.listener);
    }
  }
}
